var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.598 21.5h4v-8.01h3.604l.396-3.98h-4V7.5a1 1 0 011-1h3v-4h-3a5 5 0 00-5 5v2.01h-2l-.396 3.98h2.396v8.01z",
    fill: "currentColor"
  })));
}

var MemoSvgFacebook = /*#__PURE__*/React.memo(SvgFacebook);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuNTk3NjYgMjEuNUgxMy41OTc3VjEzLjQ5SDE3LjIwMTdMMTcuNTk3NyA5LjUxSDEzLjU5NzdWNy41QzEzLjU5NzcgNy4yMzQ3OCAxMy43MDMgNi45ODA0MyAxMy44OTA2IDYuNzkyODlDMTQuMDc4MSA2LjYwNTM2IDE0LjMzMjQgNi41IDE0LjU5NzcgNi41SDE3LjU5NzdWMi41SDE0LjU5NzdDMTMuMjcxNiAyLjUgMTEuOTk5OCAzLjAyNjc4IDExLjA2MjEgMy45NjQ0N0MxMC4xMjQ0IDQuOTAyMTUgOS41OTc2NiA2LjE3MzkyIDkuNTk3NjYgNy41VjkuNTFINy41OTc2Nkw3LjIwMTY2IDEzLjQ5SDkuNTk3NjZWMjEuNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { MemoSvgFacebook as ReactComponent };